<template>
<app-layout>
    <template #header>
        <div class="relative">
            <div class="absolute top-0 right-0">
                <inertia-link class="bg-blue-500 text-sm hover:bg-blue-700 text-white text-base font-bold py-3 px-6 rounded my-3" :href="route('pix.create')">
                    Nova Chave
                </inertia-link>
            </div>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Pix
            </h2>
        </div>
    </template>
    <div class="py-12">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                <div class="grid grid-cols-10 gap-6 mb-6">
                    <div class="col-span-8">
                        <h2 class="font-semibold text-xl text-gray-800 leading-tight mt-2">
                            Chaves Pix
                        </h2>
                    </div>
                </div>
                <flash :timeout="5000" />
                <inertia-table :enableSearch="false"
                :enablePageSize="false"
                :icon="false"
                :data="{list: customer_keys}" :params="params"
                :filters="filters" :columns="columns"
                id="id" routeName="pix.index">

                <template slot-scope="row" slot="actions">
                    <div class="w-full text-center text-blue-500">
                        <button class="px-6 py-6" @click="removeKey(row);"><i class="fa fa-trash text-red-500"></i></button>
                    </div>
                </template>
                </inertia-table>
            </div>
        </div>
    </div>
    <copia-cola :customer="customer" :errors="errors" v-show="!emptyKeys" />
    <div class="pt-0 pb-12" v-show="!emptyKeys">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                <div class="grid grid-cols-10 gap-6 mb-6">
                    <div class="col-span-8">
                        <h2 class="font-semibold text-xl text-gray-800 leading-tight mt-2">
                            Criar QR Code
                        </h2>
                    </div>
                </div>
                <jet-form-section>
                    <template #description>

                        <div class="pt-0" v-if="generatedQRCode.imagem == null && !formQRCode.processing">
                            <p>Selecione a chave PIX e crie uma cobrança por QR Code</p>
                        </div>
                        <div class="text-center pt-20" v-if="formQRCode.processing">
                            <p><i class="fas fa-spin fa-spinner fa-2x" /></p>
                            <p>Gerando seu QR Code</p>
                        </div>
                        <div class="text-center pt-0" v-if="generatedQRCode.imagem !== null && !formQRCode.processing">
                            <img :src="'data:image/jpeg;base64,'+generatedQRCode.imagem" class="w-80 h-80 mx-auto">
                            <p class="text-sm text-gray-600">
                                <span v-if="!generatedQRCode.valorEspecificado">
                                    Ao fazer a leitura deste QR Code, o pagador poderá definir o valor da transferência via Pix.
                                </span>
                                <span v-else>
                                    Cobrança de <span class="font-bold">R$ {{ generatedQRCode.valor }}</span> gerada com sucesso.
                                </span>
                            </p>
                        </div>
                    </template>

                    <template #form>
                        <div class="col-span-6 sm:col-span-6">
                            <jet-label for="key" value="Chave" />
                            <jet-auto-complete id="key" :options-list="keyList" class="mt-1 block w-full text-lg" v-model="formQRCode.selectedKey" />
                            <jet-input-error :message="form.error('selectedKey')" class="mt-2" />
                        </div>
                        <div class="col-span-6 sm:col-span-3">
                            <jet-label for="amount" value="Valor" />
                            <jet-decimal id="amount" type="text" class="mt-1 block w-full text-lg" v-model="formQRCode.amount" />
                            <jet-input-error :message="form.error('amount')" class="mt-2" />
                        </div>
                        <div class="col-span-6 sm:col-span-3">
                            <jet-label for="receiver_code" value="Identificador da cobrança (Opcional)" />
                            <jet-input id="receiver_code" maxlength="25" type="text" class="mt-1 block w-full text-lg" v-model="formQRCode.transfer_code" />
                            <jet-input-error :message="form.error('transfer_code')" class="mt-2" />
                        </div>
                        <div class="col-span-6">
                            <jet-label for="description" value="Descrição (Opcional)" />
                            <jet-input id="description" maxlength="50" type="text" class="mt-1 block w-full text-lg" v-model="formQRCode.description" @change="removeSpecialChars($event)" />
                            <jet-input-error :message="form.error('description')" class="mt-2" />
                        </div>
                    </template>
                </jet-form-section>
                <jet-section-border class="py-2" />
                <div class="grid grid-cols-2">
                    <div class="text-left">
                        <button v-if="generatedQRCode.imagem !== null && !formQRCode.processing"
                        @click="copyQRCode()" class="w-1/2 ml-4 inline-flex items-center px-4 py-3 bg-gray-800
                                        border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest
                                        hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150">
                            <div class="w-full text-center">Copiar Código Pix</div>
                        </button>
                    </div>
                    <div class="text-right">
                        <button @click="generateQRCode()" class="bg-green-500 text-sm hover:bg-green-700 text-white text-base font-bold my-0 py-3 px-6 rounded">
                            Gerar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <jet-confirmation-modal :show="removeConfirm" @close="removeConfirm=false">
        <template #title>
            Excluir chave PIX
        </template>

        <template #content>
            <div class="mt-20">
                <jet-form-section>
                    <template #title>
                        Autenticação
                    </template>

                    <template #description>
                        Informe o código de autorização para autenticar e concluir sua solicitação
                    </template>

                    <template #form>
                        <div class="col-span-12" v-if="form.deleteKey != null">
                            Informe o código de autenticação<br>para excluir a chave:<br><b>{{ form.deleteKey.item.key || "" }}</b>.
                        </div>
                        <div class="col-span-12">
                            <jet-label for="google_code" value="Código de Confirmação" />
                            <jet-input id="google_code" type="number" class="mt-1 block w-full" v-model="form.google_code" />
                            <jet-input-error :message="form.error('google_code')" class="mt-2" />
                        </div>
                    </template>
                </jet-form-section>
            </div>
        </template>

        <template #footer>
            <jet-secondary-button @click.native="removeConfirm = false">
                Agora não
            </jet-secondary-button>

            <jet-ok-button class="ml-2" @click.native="save()">
                Confirmar
            </jet-ok-button>
        </template>
    </jet-confirmation-modal>
</app-layout>
</template>

<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';
import JetConfirmationModal from './../../Jetstream/ConfirmationModal';
import JetDangerButton from "../../Jetstream/DangerButton";
import JetOkButton from "../../Jetstream/OkButton";
import JetFormSection from "../../Jetstream/FormSection";
import JetLabel from "../../Jetstream/Label";
import JetInput from "../../Jetstream/Input";
import JetInputError from "../../Jetstream/InputError";
import JetSecondaryButton from "../../Jetstream/SecondaryButton";
import JetSectionBorder from './../../Jetstream/SectionBorder'
import JetDecimal from "../../Jetstream/Decimal";
import CopiaCola from './CopiaCola.vue';
import Button from '../../Jetstream/Button.vue';

export default {
    components: {
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
        JetConfirmationModal,
        JetDangerButton,
        JetOkButton,
        JetFormSection,
        JetLabel,
        JetInput,
        JetInputError,
        JetSecondaryButton,
        JetSectionBorder,
        JetDecimal,
        CopiaCola,
        Button
    },
    props: ['customer', 'customer_keys','errors'],
    data() {
        return {
            emptyKeys:false,
            removeConfirm: false,
            showRemoved:false,
            generatedQRCode: {
                emv: null,
                imagem: null,
                valorEspecificado: false,
                valor: ""
            },
            columns: [{
                    text: 'Chave',
                    className: 'text-left',
                    key: 'key',
                    sortable: false
                },
                {
                    text: 'Tipo de Chave',
                    className: 'text-left',
                    key: 'tipoChave',
                    sortable: false
                },
                {
                    text: 'Data Criação',
                    className: 'text-left',
                    key: 'date',
                    sortable: false
                },
                {
                    text: 'Ação',
                    className: 'text-center',
                    key: 'actions',
                    sortable: false
                },
            ],
            form: this.$inertia.form({
                _method: 'DELETE',
                deleteKey: null,
                google_code: null,
            }, {
                resetOnSuccess: false,
            }),
            formQRCode: {
                processing: false,
                selectedKey: null,
                transfer_code: null,
                description: null,
                amount: 0
            },
            filters: [],
            params: {},
        }
    },
    watch:{
        'formQRCode.transfer_code':{
            handler: function(val){
                 this.formQRCode.transfer_code = val.replace(/\W/g, "");
            }
        },
        'formQRCode.description':{
            handler: function(val){
                 this.formQRCode.description = val.replace(/[^\w\s]/gi, '')
                 this.$forceUpdate();
            }
        },
    },
    methods: {
        show: function (item) {
            this.$inertia.get(this.route('contact.show', item.id));
        },
        removeKey: function (item) {
            this.form.deleteKey = item;
            this.removeConfirm = true;
            window.scrollTo(0, 0);
        },
        resetQRCode: function(){
            this.generatedQRCode= {
                emv: null,
                imagem: null,
                valorEspecificado: false,
                valor: ""
            }
        },
        generateQRCode: function () {
            let data = this.formQRCode;
            if (!data.selectedKey) {
                return;
            }
            let endpoint = `json/pix/qrcode/create?key=${encodeURIComponent(data.selectedKey.data.key)}&type=${data.selectedKey.data.key_type}
            &amount=${data.amount}&transfer_code=${data.transfer_code}&description=${data.description}`
            this.formQRCode.processing = true;
            fetch(endpoint)
                .then(res => {
                    res.json().then(json => {
                        if (json.error) {
                            this.$toast.open({
                                message: json.error,
                                type: 'error',
                                duration: 5000,
                                position: 'top-right'
                            });
                            this.resetQRCode();
                            return;
                        }
                        this.generatedQRCode = json;
                    });
                })
                .finally(() => {
                    this.formQRCode.processing = false;
                })
        },
        save: function () {
            this.form.post('/pix/delete', {
                preserveScroll: true,
                onError: (e) => {
                    this.form.processing = false;
                    this.removeConfirm = (this.errors.google_code) ? true : false;
                    this.$forceUpdate();
                },
                onSuccess: () => {
                    this.removeConfirm = false;
                    this.$forceUpdate();
                }
            });
        },
        copyQRCode: function () {
            try{
                const clipboardData =
                    window.clipboardData ||
                    navigator.clipboard;
                clipboardData.writeText(this.generatedQRCode.emv);
                this.$toast.open({
                    message: 'Código PIX Copia e Cola copiado com sucesso',
                    type: 'success',
                    duration: 5000,
                    position: 'top-right'
                });
            }catch(e){
                this.$toast.open({
                    message: "Seu navegador não da suporte a esta função.",
                    type: 'error',
                    duration: 5000,
                    position: 'top-right'
                });
            }
        }
    },
    computed: {
        keyList: function () {
            let newList = this.customer_keys.map(function (k, index) {
                    return {
                        id: index,
                        name: k.key,
                        data: k
                    };
            });
            return newList;
        }
    }
}
</script>
